module.exports = __webpack_public_path__ + "static/media/list_blue.6a796779.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/list_blue.svg
// module id = ./src/assets/media/forum/list_blue.svg
// module chunks = 16